(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bambu-profiles"] && !Shopify.designMode) return;
  try {
    (function () {
  // --- Printer selector logic ---
  var cardEl = document.querySelector('[data-bambu-profiles]');
  if (cardEl) {
    var selector = cardEl.querySelector('.bambu-printer-selector');
    var pills = selector ? Array.prototype.slice.call(selector.querySelectorAll('.bambu-printer-pill')) : [];
    var panels = Array.prototype.slice.call(cardEl.querySelectorAll('.bambu-pack-panel'));

    function showPanel(index) {
      var selectedIndex = String(index);

      pills.forEach(function (pill) {
        var isSelected = pill.getAttribute('data-pack-index') === selectedIndex;
        pill.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        pill.setAttribute('tabindex', isSelected ? '0' : '-1');
        pill.classList.toggle('is-selected', isSelected);
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-pack-panel') !== selectedIndex;
      });
    }

    if (selector) {
      selector.addEventListener('click', function (e) {
        var pill = e.target.closest('.bambu-printer-pill');
        if (!pill) return;
        showPanel(pill.getAttribute('data-pack-index'));
      });

      showPanel(0);
    }
  }

  // --- Download with spinner (your existing behavior) ---
  document.addEventListener('click', function(event) {
    var button = event.target.closest('.bambu-download-btn');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var url = button.getAttribute('href');
    if (!url) return;

    var labelSpan = button.querySelector('.btn-label');
    var spinner = button.querySelector('.btn-spinner');

    function getFilenameFromContentDisposition(headerValue) {
      if (!headerValue) return '';
      // RFC 6266 / 5987 (filename* takes precedence)
      var matchStar = headerValue.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
      if (matchStar && matchStar[1]) {
        try {
          return decodeURIComponent(matchStar[1].trim().replace(/^"|"$/g, ''));
        } catch (e) {
          return matchStar[1].trim().replace(/^"|"$/g, '');
        }
      }
      var match = headerValue.match(/filename=([^;]+)/i);
      if (match && match[1]) {
        return match[1].trim().replace(/^"|"$/g, '');
      }
      return '';
    }

    function getFilenameFromUrl(downloadUrl) {
      if (!downloadUrl) return '';
      var clean = downloadUrl.split('#')[0].split('?')[0];
      var parts = clean.split('/');
      var last = parts[parts.length - 1] || '';
      try {
        return decodeURIComponent(last);
      } catch (e) {
        return last;
      }
    }

    if (button.dataset.downloading === 'true') return;
    button.dataset.downloading = 'true';

    // Preserve the original label so printer names don't disappear.
    if (!button.dataset.originalLabel && labelSpan) {
      button.dataset.originalLabel = labelSpan.textContent;
    }

    if (labelSpan) {
      labelSpan.textContent = 'Starting download…';
    }
    if (spinner) {
      spinner.style.display = 'inline-block';
    }

    fetch(url)
      .then(function(response) {
        if (!response.ok) throw new Error('Network response was not ok');
        var headerName = response.headers.get('content-disposition');
        var resolvedName =
          getFilenameFromContentDisposition(headerName) ||
          getFilenameFromUrl(url) ||
          button.getAttribute('data-filename') ||
          'download';

        return response.blob().then(function (blob) {
          return { blob: blob, filename: resolvedName };
        });
      })
      .then(function(result) {
        var objectUrl = URL.createObjectURL(result.blob);
        var tempLink = document.createElement('a');
        tempLink.href = objectUrl;
        tempLink.download = result.filename;
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(objectUrl);
      })
      .catch(function() {})
      .finally(function() {
        button.dataset.downloading = 'false';
        if (labelSpan) {
          labelSpan.textContent = button.dataset.originalLabel || labelSpan.textContent;
        }
        if (spinner) {
          spinner.style.display = 'none';
        }
      });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
